import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; // Importa useNavigate
import styles from './ImageGallerySection.module.css';
import image1 from '../../assets/tratamiento_3.jpg';
import image2 from '../../assets/tratamiento_5.jpg';
import image3 from '../../assets/tratamiento_4.jpg';

const ImageGallerySection = () => {
    const gallerySectionRef = useRef(null);
    const navigate = useNavigate(); // Hook para la navegación

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // Agrega la clase "active" a los overlays cuando la sección es visible
                        const overlays = entry.target.querySelectorAll(`.${styles.overlay}`);
                        overlays.forEach((overlay) => overlay.classList.add(styles.active));
                    } else {
                        // Remueve la clase "active" cuando la sección no es visible
                        const overlays = entry.target.querySelectorAll(`.${styles.overlay}`);
                        overlays.forEach((overlay) => overlay.classList.remove(styles.active));
                    }
                });
            },
            {
                threshold: 0.5, // Activa la animación cuando el 50% de la sección es visible
            }
        );

        if (gallerySectionRef.current) {
            observer.observe(gallerySectionRef.current);
        }

        return () => {
            if (gallerySectionRef.current) {
                observer.unobserve(gallerySectionRef.current);
            }
        };
    }, []);

    const galleryItems = [
        {
            id: 1,
            imagen: image1,
            title: 'Exosomas',
            description: 'Rejuvenecimiento y cuidado facial personalizado para todo tipo de piel.',
            url: '/servicios/exosomas', // Ruta a la que debe redirigir
        },
        {
            id: 2,
            imagen: image2,
            title: 'Hiperhidrosis',
            description: 'Servicios profesionales para mantener tu cabello saludable y brillante.',
            url: '/servicios/hiperhidrosis', // Ruta a la que debe redirigir
        },
        {
            id: 3,
            imagen: image3,
            title: 'Plasma capilar',
            description: 'Relájate y rejuvenece con nuestros tratamientos especializados de masaje.',
            url: '/servicios/plasma-capilar', // Ruta a la que debe redirigir
        },
    ];

    return (
        <section ref={gallerySectionRef} className={styles.gallerySection}>
            <div className={styles.galleryContainer}>
                {galleryItems.map((item) => (
                    <div key={item.id} className={styles.galleryItem}>
                        <div className={styles.imageContainer}>
                            <img src={item.imagen} alt={item.title} className={styles.galleryImage} />
                            <div className={styles.overlay}>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                                {/* Botón que redirige a la URL especificada */}
                                <button
                                    className={styles.learnMoreBtn}
                                    onClick={() => navigate(item.url)} // Navega a la URL al hacer clic
                                >
                                    Más Información
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ImageGallerySection;